var _path, _path2, _path3, _path4, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUz = function SvgUz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1eb53a",
    d: "M0 341.3h512V512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0099b5",
    d: "M0 0h512v170.7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 163.8h512v184.4H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 174h512v164H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 143.4,
    cy: 81.9,
    r: 61.4,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.8,
    cy: 81.9,
    r: 61.4,
    fill: "#0099b5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(278.5 131)scale(2.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uz_svg__e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uz_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uz_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uz_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uz_svg__a",
    d: "M0-6-1.9-.3 1 .7"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__c",
    width: "100%",
    height: "100%",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__d",
    width: "100%",
    height: "100%",
    y: -24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__d",
    width: "100%",
    height: "100%",
    y: -48
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__e",
    width: "100%",
    height: "100%",
    x: 24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__e",
    width: "100%",
    height: "100%",
    x: 48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__d",
    width: "100%",
    height: "100%",
    x: -48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__d",
    width: "100%",
    height: "100%",
    x: -24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uz_svg__d",
    width: "100%",
    height: "100%",
    x: -24,
    y: -24
  }))));
};
export default SvgUz;